export const setThemeColor = (red, green, blue) => {
	let tag = document.querySelector("meta[name=theme-color]");
	tag.setAttribute("content", `rgb(${red}, ${green}, ${blue})`);
};
